import { render, staticRenderFns } from "./SosButton.vue?vue&type=template&id=c38c7382&scoped=true"
import script from "./SosButton.vue?vue&type=script&lang=js"
export * from "./SosButton.vue?vue&type=script&lang=js"
import style0 from "./SosButton.vue?vue&type=style&index=0&id=c38c7382&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38c7382",
  null
  
)

export default component.exports